import React, { useContext } from "react";
import { SelectElement } from "../../HtmlComponents/SelectElement";
import { BiChevronDownCircle, BiChevronUpCircle } from "react-icons/bi";
import { InputElement } from "../../HtmlComponents/InputElement";
import { formattedDate } from "../../functions/functions";
import { FaPrint } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { ShowExpenseContext } from "./types";
import { Days, Months,  Years } from "../../functions/Dates";

const FilterExpenses: React.FC = () => {
  const {
    day, setDay,
    month, setMonth,
    year, setYear,
    showSwitchDate, setShowSwitchDate,
    startDate, setStartDate,
    endDate, setEndDate,
  } = useContext(ShowExpenseContext);

  const { t } = useTranslation()

  return (
    <div className="flex justify-start gap-2 mt-3">
      {showSwitchDate ? (
        <>
          <BiChevronUpCircle className="text-main" style={{ fontSize: "22px" }} onClick={() => setShowSwitchDate(!showSwitchDate)} />
          <InputElement divClass="flex justify-center items-center gap-1" type="date" name={t("Debut")} value={formattedDate(startDate.toString())} setValue={setStartDate} />
          <InputElement divClass="flex justify-center items-center gap-1" type="date" name={t("Fin")} value={formattedDate(endDate.toString())} setValue={setEndDate} />
        </>
      ) : (
        <>
          <BiChevronDownCircle className="text-main" style={{ fontSize: "22px" }} onClick={() => setShowSwitchDate(!showSwitchDate)} />
          <span className="my-2 px-1 pt-1 bg-main rounded" onClick={() => {
            setDay(new Date().getDate())
            setMonth(new Date().getMonth() + 1)
            setYear(new Date().getFullYear())
          }}>{t("Aujourd'hui")}</span>
          <SelectElement valueType="string" value={day} setValue={setDay} defaultOption={<option value={"jour"}>{t("jour")}</option>} options={Days} />
          <SelectElement valueType="string" value={month} setValue={setMonth} defaultOption={<option value={"mois"}>{t("mois")}</option>} options={Months} />
          <SelectElement valueType="string" value={year} setValue={setYear} options={Years} />
        </>
      )}
      <FaPrint onClick={() => {
        window.print()
      }} className="text-second" style={{ fontSize: "22px" }} />

    </div>
  );
};

export default FilterExpenses;
